import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import Link from '@mui/material/Link'
import { navigate } from 'gatsby'
import NavLink from 'src/components/atoms/NavLink'
import NavDropdown from 'src/components/molecules/NavDropdown'
import { Typography } from '@mui/material'
import {
  NavigationDocumentDataBodyLinksSliceItem,
  NavigationDocumentDataBodyMenuSliceItem,
  NavigationDocumentDataBodySubmenuSliceItem,
} from '../../../../types.generated'

type VariantType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2'

interface Props {
  variant?: VariantType
  contrast?: boolean
  bold?: boolean
  menu?: NavigationDocumentDataBodyMenuSliceItem[]
  submenu?: NavigationDocumentDataBodySubmenuSliceItem[]
  links?: NavigationDocumentDataBodyLinksSliceItem[]
}
// Top nav links test
const NavLinks: React.FC<Props> = ({ variant = undefined, contrast, menu, submenu, links }) => {
  return (
    <>
      {menu?.map(({ url, url_external, hide, title, id, dropdown }) => {
        return !dropdown
          ? !hide && (
            <NavLink
              key={id.text}
              to={url.text}
              href={url_external.text}
              bold
              variant={variant}
              contrast={contrast}
            >
              {title.text}
            </NavLink>
          )
          : !hide && (
            <NavDropdown
              key={id.text}
              label={title.text}
              bold
              variant={variant}
              contrast={contrast}
            >
              {submenu?.map(
                ({ url, url_external, hide, title, menu_id, submenu_id }) => {
                  const isLinkPath =
                    menu_id.text === id.text && !url_external.text
                  return isLinkPath
                    ? !hide && (
                      <MenuItem
                        key={`submenu-${submenu_id}`}
                        onClick={() => navigate(url.text)}
                      >
                        <Typography
                          sx={{ fontWeight: 'medium' }}
                          variant={variant}
                        >
                          {title.text}
                        </Typography>
                      </MenuItem>
                    )
                    : !hide && (
                      <MenuItem key={`submenu-${submenu_id}`}>
                        <Typography
                          sx={{ fontWeight: 'medium' }}
                          variant={variant}
                        >
                          <Link
                            target="_blank"
                            key={`submenu-${submenu_id}`}
                            href={url_external.text}
                            title={title.text}
                          >
                            {title.text}
                          </Link>
                        </Typography>
                      </MenuItem>
                    )
                },
              )}
            </NavDropdown>
          )
      })}
    </>
  )
}

export default NavLinks

interface NavLinksAllExposedProps {
  variant?: VariantType
  contrast?: boolean
  bold?: boolean
  links: NavigationDocumentDataBodyLinksSliceItem[]
}

// Bottom nav links
export const NavLinksAllExposed: React.FC<NavLinksAllExposedProps> = ({
  variant = undefined,
  contrast,
  bold = true,
  links,
}) => {
  return (
    <>
      {links?.map(({ url, title, url_external, hide, link_id }) => {
        return !url_external?.text
          ? !hide && (
            <NavLink
              key={`link-${link_id}`}
              to={url.text}
              href={url_external?.text}
              bold={bold}
              variant={variant}
              contrast={contrast}
            >
              {title?.text}
            </NavLink>
          )
          : !hide && (
            <Link
              target="_blank"
              key={`link-${link_id}`}
              href={url_external?.text}
              title={title?.text}
            >
              {title?.text}
            </Link>
          )
      })}
    </>
  )
}